<template>
  <div class="home-content">
    <div class="askod-grid-item">
      <v-img
        max-height="100%"
        :src="getImage(content.mainBlock.image)"
        gradient="to bottom right, rgba(32, 40, 75, 0.9), rgb(32, 40, 75, 0.5)"
        aspect-ratio="1"
        class="grid-content-holder"
      >
        <router-link class="home-item-link" :to="`/page/${mainBlockLink}`">
          <span class="second-text">
            {{ content.mainBlock.additionalText }}
          </span>
          <div class="main-word">
            {{ content.mainBlock.mainText }}
          </div>
          <div class="d-flex">
            <div class="home-button">{{$t('home.view')}}</div>
          </div>
        </router-link>
      </v-img>
    </div>
    <div class="youtube-container d-flex flex-column">
      <iframe
        width="100%"
        height="100%"
        class="flex"
        :src="content.link"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
    <div class="support">
      <!-- <carousel
        :items="content.content"
        gradient="rgba(0, 0, 0, 0.3),rgba(0, 0, 0, 0.3)"
      /> -->

      <v-img
        class="grid-content-holder"
        :src="getImage(content.secondBlock.image)"
        :contain="false"
        :aspect-ratio="$vuetify.breakpoint.mobile ? 1 : 1.8"
        max-height="100%"
        gradient="to bottom left,rgba(25, 121, 121, 0.9), rgb(25, 121, 121, 0.5)"
      >
        <router-link class="home-item-link" :to="`${secondBlockLink}`">
          <span class="second-text">
            {{ content.secondBlock.additionalText }}
          </span>
          <div class="main-word">{{ content.secondBlock.mainText }}</div>
          <div class="d-flex">
            <div class="home-button">{{$t('home.view')}}</div>
          </div>
        </router-link>
      </v-img>
    </div>
  </div>
</template>
<script>
import serviceDataAccess from '../../services/service.data-access'
export default {
  name: 'HomeComponent',
  props: ['model'],
  data: () => ({
    mainBlockLink: null,
    secondBlockLink: null
  }),
  computed: {
    content: function () {
      return this.model.content
    }
  },
  async created() {
    const result = await serviceDataAccess.getPagesLinks([
      this.content.mainBlock.pageId,
      this.content.secondBlock.pageId
    ])
    const mainBlockLink = result.find(
      (e) => e.pageId === this.content.mainBlock.pageId
    )
    const secondBlockLink = result.find(
      (e) => e.pageId === this.content.secondBlock.pageId
    )

    this.mainBlockLink = mainBlockLink?.fullLink
    this.secondBlockLink = secondBlockLink.fullLink
  },
  methods: {
    getImage(file) {
      return window.URL.createObjectURL(file, { type: file.type })
    }
  }
}
</script>
<style lang="scss">
@import '~vuetify/src/styles/settings/_variables';

.home-content {
  @media #{map-get($display-breakpoints, 'xs-only')} {
    & {
      display: block;
      height: auto;
    }
  }

  height: calc(100vh - 6rem);
  display: grid;
  max-width: 100% !important;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  padding: 0 !important;
  margin: 0 !important;
  flex: 1 1 auto !important;

  .grid-content-holder {
    color: white;
    padding-left: 6rem;
    padding-right: 4rem;

    &:hover {
      .v-image__image {
        transform: scale(1.05, 1.05);
      }
    }

    .v-image__image {
      transform: scale(1, 1);
      transition: transform 0.4s;
    }

    .main-word {
      font-size: 8rem;
    }
    .second-text {
      font-size: 2rem;
      color: white;
    }
  }

  .askod-grid-item,
  .support,
  .v-responsive__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .askod-grid-item {
    grid-row-start: 1;
    grid-row-end: 3;
    grid-column-start: 1;
    grid-column-end: 1;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .youtube-container {
    grid-row-start: 1;
    grid-row-end: 1;
    grid-column-start: 2;
    grid-column-end: 2;
    min-height: 30rem;
  }

  .support {
    grid-row-start: 2;
    grid-row-end: 2;
    grid-column-start: 2;
    grid-column-end: 2;
    background-color: grey;
    overflow: auto;
  }

  .home-item-link {
    text-decoration: none;
    color: white;

    // :hover {
    //   text-decoration: underline;
    // }
  }
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .home-content {
    .grid-content-holder,
    .carousel-item-text {
      padding-left: $md-indent;

      .main-word,
      .main-text a {
        font-size: 5rem;
      }
    }
  }
}

.home-button {
  padding: 12px 24px;
  display: flex;
  justify-content: center;
  font-size: 20px;
  border: 1px solid white;
  align-items: center;
}
</style>
